import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../config/interceptor";

export const useStates = () => {
  return useQuery({
    queryKey: ["states"],
    queryFn: async () => {
      const res = await axiosInstance.get("/api/property/static/states/index.json");
      return res.data;
    },
    // The state catalogue is a static ~110KB JSON that changes at deploy time,
    // not per session. Without these the react-query defaults (staleTime 0 +
    // refetchOnWindowFocus) pulled it a second time on the very first focus,
    // which is why Lighthouse saw two 110KB downloads of the same file. Mirrors
    // the options already used by useStaticPropertyData.
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
